import {E} from './util.mjs'
import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as u from './util.mjs'
import * as r from './route_util.mjs'

/*
This routing table is used both in SSR and on the client.
For SSR-only routes, see `cmd-srv.mjs`→`Srv..res`.
*/
const ROUTES = r.Routes.from(u.vacOf(
  {pat: /^[/]?$/, han: async ctx => (await u.imp(import(`./views/main-page.mjs`))).MainPage(ctx)},

  {pat: `/main`,                  han: async ctx => (await u.imp(import(`./views/main-page.mjs`))).MainPage(ctx)},
  {pat: c.LINK_GIFT_CARDS,        han: async ctx => (await u.imp(import(`./views/gift-cards.mjs`))).GiftCards(ctx)},
  {
    pat: c.LINK_GIFT_CARDS_TERMS,
    han: async ctx => (await u.imp(import(`./views/gift-cards-terms.mjs`))).GiftCardsTerms(ctx)
  },

  {
    pat: /^[/]gift-cards[/](?<id>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/gift-card-showcase.mjs`))).GiftCardShowCasePage(ctx),
  },
  {
    pat: `/gift-cards/purchase/any`,
    han: async ctx => (await u.imp(import(`./views/gift-card-purchase.mjs`))).GiftCardPurchasePage(ctx),
  },
  {
    pat: /^[/]gift-cards[/]purchase[/](?<amount>\d+)$/,
    han: async ctx => (await u.imp(import(`./views/gift-card-purchase.mjs`))).GiftCardPurchasePage(ctx),
  },

  {pat: c.LINK_ARTICLES, han: async ctx => (await u.imp(import(`./views/articles.mjs`))).ArticlesPage(ctx)},

  {
    pat: /^[/]articles[/](?<slug>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/article.mjs`))).ArticlePage(ctx),
  },

  {pat: /^[/]categories[/](?<catIntId>[^/]+)$/,          han: async ctx => (await u.imp(import(`./views/articles.mjs`))).ArticlesPage(ctx)},
  {pat: /^[/]articles[/]category[/](?<catSlug>[^/]+)$/,  han: async ctx => (await u.imp(import(`./views/articles.mjs`))).ArticlesPage(ctx)},

  {pat: `/user/register`, han: redir(c.LINK_LOGIN)},
  {
    pat: `/user/upgrade`,
    han: async ctx => (await u.imp(import(`./views/registration.mjs`))).UpgradePage(ctx),
  },
  {
    pat: `/practitioners/register`,
    han: async ctx => (await u.imp(import(`./views/registration.mjs`))).practRegRedirect(ctx),
  },
  {
    pat: `/organizations/register`,
    han: async ctx => (await u.imp(import(`./views/registration.mjs`))).orgRegRedirect(ctx),
  },

  {pat: `/practitioners`,         han: redir(c.LINK_PRACTITIONERS)},
  {pat: c.LINK_PRACTITIONERS,     han: async ctx => (await u.imp(import(`./views/practitioners.mjs`))).PractitionersPage(ctx)},
  {
    pat: c.LINK_PRACTITIONERS_MAP,
    han: async ctx => (await u.imp(import(`./views/practitioners-map.mjs`))).PractMapPage(ctx),
  },
  {pat: `/practitioners/profile`, han: redir(c.LINK_MY_PROFILE)},

  {
    pat: /^[/](?:practitioners|organizations)[/](?<id>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/pract.mjs`))).PractPageByIntId(ctx),
  },
  {
    pat: /^[/]@(?<slug>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/pract.mjs`))).PractPageBySlug(ctx),
  },

  {pat: `/luminaries`,                      han: async ctx => (await u.imp(import(`./views/luminaries.mjs`))).LuminariesPage(ctx)},
  {pat: /^[/]luminaries[/](?<slug>[^/]+)$/, han: async ctx => (await u.imp(import(`./views/luminary-showcase.mjs`))).LuminaryShowcasePage(ctx)},

  {pat: c.LINK_LOGIN,              han: async ctx => (await u.imp(import(`./views/auth.mjs`))).AuthLoginPage(ctx, {redirect: c.LINK_MY_PROFILE})},
  {pat: `/auth/signup`,            han: redir(c.LINK_LOGIN)},
  {pat: `/auth/verification-done`, han: async ctx => (await u.imp(import(`./views/auth.mjs`))).AuthVerificationDonePage(ctx)},

  // IMPORTANT: Do not change link for Our Mission.
  // This link is used for SEO.
  {pat: `/our-mission`,            han: async ctx => (await u.imp(import(`./views/our-mission.mjs`))).OurMissionPage(ctx)},
  {pat: `/faq`,                    han: async ctx => (await u.imp(import(`./views/faq.mjs`))).FaqPage(ctx)},
  {pat: `/contact-us`,             han: async ctx => (await u.imp(import(`./views/contact-us.mjs`))).ContactUsPage(ctx)},
  {pat: `/privacy-policy`,         han: async ctx => (await u.imp(import(`./views/static-pages.mjs`))).PrivacyPolicyPage(ctx)},
  {pat: `/terms-of-service`,       han: async ctx => (await u.imp(import(`./views/static-pages.mjs`))).TermsOfService(ctx)},
  {pat: `/info/privacy-policy`,    han: redir(`/privacy-policy`)},
  {pat: `/info/terms-of-service`,  han: redir(`/terms-of-service`)},

  {pat: c.LINK_SEARCH,               han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).SearchPage(ctx)},
  {pat: c.LINK_SEARCH_SERVICES,      han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).ServiceSearchPage(ctx)},
  {pat: c.LINK_SEARCH_EVENTS,        han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).EventSearchPage(ctx)},
  {pat: c.LINK_SEARCH_VIDEOS,        han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).VideoSearchPage(ctx)},
  {pat: c.LINK_SEARCH_BOOKS,         han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).BookSearchPage(ctx)},
  {pat: c.LINK_SEARCH_ARTICLES,      han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).ArticleSearchPage(ctx)},
  {pat: c.LINK_SEARCH_PRACTITIONERS, han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).PractSearchPage(ctx)},
  {pat: c.LINK_SEARCH_ORGANIZATIONS, han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).OrgSearchPage(ctx)},

  // Now it supports only services by ad purposes.
  {pat: `/lucky/services`,         han: async ctx => (await u.imp(import(`./views/search-page.mjs`))).LuckyRedirect(ctx)},
  {
    pat: /^[/]services[/](?<slug>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/service.mjs`))).ServicePage(ctx),
  },

  {pat: c.LINK_SERVICES,                                han: async ctx => (await u.imp(import(`./views/services.mjs`))).ServicesPage(ctx)},
  {pat: /^[/]services[/]category[/](?<catSlug>[^/]+)$/, han: async ctx => (await u.imp(import(`./views/services.mjs`))).ServicesPage(ctx)},
  {pat: c.LINK_EVENTS,                                  han: async ctx => (await u.imp(import(`./views/services.mjs`))).EventsPage(ctx)},
  {pat: /^[/]events[/]category[/](?<catSlug>[^/]+)$/,   han: async ctx => (await u.imp(import(`./views/services.mjs`))).EventsPage(ctx)},
  {pat: c.LINK_VIDEOS,                                  han: async ctx => (await u.imp(import(`./views/services.mjs`))).VideosPage(ctx)},
  {pat: /^[/]videos[/]category[/](?<catSlug>[^/]+)$/,   han: async ctx => (await u.imp(import(`./views/services.mjs`))).VideosPage(ctx)},
  {pat: c.LINK_BOOKS,                                   han: async ctx => (await u.imp(import(`./views/services.mjs`))).BooksPage(ctx)},
  {pat: /^[/]books[/]category[/](?<catSlug>[^/]+)$/,    han: async ctx => (await u.imp(import(`./views/services.mjs`))).BooksPage(ctx)},
  {pat: c.LINK_COURSES,                                 han: async ctx => (await u.imp(import(`./views/services.mjs`))).CoursesPage(ctx)},
  {pat: /^[/]courses[/]category[/](?<catSlug>[^/]+)$/,  han: async ctx => (await u.imp(import(`./views/services.mjs`))).CoursesPage(ctx)},

  {
    pat: /^[/]live-stream[/](?<id>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/live-stream-daily.mjs`))).LiveStreamPage(ctx),
  },

  // New Personal Account
  {
    pat: c.LINK_MY_ARTICLES,
    han: async ctx => (await u.imp(import(`./views/my-acc-articles.mjs`))).MyArticlesPage(ctx),
  },
  {
    pat: c.LINK_MY_ARTICLES_NEW,
    han: async ctx => (await u.imp(import(`./views/my-acc-article-new-update.mjs`))).NewArticlePage(ctx),
  },
  {
    pat: /^[/]my-articles[/](?<slug>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-article-new-update.mjs`))).ArticleEditPage(ctx),
  },

  {pat: /^[/]my-articles[/](?<slug>[^/]+)[/]moderation$/, han: async ctx => (await u.imp(import(`./views/my-acc-article-new-update.mjs`))).ArticleModerationPage(ctx)},

  {
    pat: c.LINK_MY_PROFILE,
    han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx),
  },
  {
    pat: /^[/]profile[/](?<slug>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx),
  },

  {pat: c.LINK_MY_REFERRAL,           han: async ctx => (await u.imp(import(`./views/referral/my-referral.mjs`))).MyReferralPage(ctx)},
  {pat: c.LINK_MY_NETWORKS,           han: async ctx => (await u.imp(import(`./views/my-acc-social.mjs`))).MyAccNetworksPage(ctx)},
  {pat: c.LINK_MY_PROFILE_MODERATION, han: async ctx => (await import(`./views/my-acc-profile.mjs`)).PractitionerModerationPage(ctx)},
  {pat: c.LINK_MY_PROFILE_REPLIES,    han: async ctx => (await import(`./views/my-acc-profile.mjs`)).MyRepliesPage(ctx)},

  {pat: c.LINK_MY_PAYMENT_METHODS,    han: async ctx => (await import(`./views/account/payment-methods.mjs`)).PaymentMethods(ctx)},

  {
    pat: c.LINK_MY_FAVORITES,
    han: async ctx => (await u.imp(import(`./views/my-favorites.mjs`))).MyFavoritesPage(ctx)
  },

  {pat: c.LINK_MY_FIN_TRANSFERS, han: async ctx => (await u.imp(import(`./views/my-acc-wallet.mjs`))).MyFinTransfers(ctx)},

  ...purchasesRoutes(),

  {
    pat: c.LINK_MY_SERVICES,
    han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyServices(ctx),
  },
  {
    pat: c.LINK_MY_SERVICES_CREATE,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceCreatePage(ctx),
  },
  {
    pat: /^[/]my-services[/](?<id>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceEditPage(ctx),
  },
  {
    pat: /^[/]my-services[/](?<slug>[^/]+)[/]moderation$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceModerationPage(ctx),
  },
  {
    pat: /^[/]my-services[/](?<slug>[^/]+)[/]publish$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServicePublishPage(ctx),
  },

  {
    pat: c.LINK_MY_EVENTS,
    han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyEvents(ctx),
  },
  {
    pat: c.LINK_MY_EVENTS_CREATE,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).EventCreatePage(ctx),
  },
  {
    pat: /^[/]my-events[/](?<id>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).EventEditPage(ctx),
  },
  {pat: /^[/]my-events[/](?<slug>[^/]+)[/]moderation$/, han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceModerationPage(ctx)},
  {
    pat: /^[/]my-events[/](?<id>[^/]+)[/]sched/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).EventSchedPage(ctx),
  },

  {
    pat: c.LINK_MY_VIDEOS,
    han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyVideos(ctx),
  },
  {
    pat: c.LINK_MY_VIDEOS_CREATE,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).VideoCreatePage(ctx),
  },
  {
    pat: /^[/]my-videos[/](?<id>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).VideoEditPage(ctx),
  },
  {pat: /^[/]my-videos[/](?<slug>[^/]+)[/]moderation$/, han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceModerationPage(ctx)},
  {
    pat: /^[/]my-videos[/](?<id>[^/]+)[/]upload$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).VideoUploadPage(ctx),
  },

  {
    pat: c.LINK_MY_BOOKS,
    han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyBooks(ctx),
  },
  {
    pat: c.LINK_MY_BOOKS_CREATE,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).BookCreatePage(ctx),
  },
  {
    pat: /^[/]my-books[/](?<id>[^/]+)[/]edit$/,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).BookEditPage(ctx),
  },
  {pat: /^[/]my-books[/](?<slug>[^/]+)[/]moderation$/, han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceModerationPage(ctx)},

  ...salesRoutes(),

  {
    pat: c.LINK_PLANS,
    han: async ctx => (await u.imp(import(`./views/my-membership.mjs`))).MyMembershipPage(ctx)
  },
  {
    pat: c.LINK_MY_INSTALL_MOBILE_APP,
    han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).ServiceInstallMobileAppPage(ctx),
  },
  {pat: c.LINK_MY_GIFT_CARDS, han: async ctx => (await u.imp(import(`./views/my-acc-gift-cards.mjs`))).MyAccGiftCards(ctx)},
  {pat: c.LINK_MY_PREFERENCES, han: async ctx => (await u.imp(import(`./views/my-acc-pref.mjs`))).MyAccPrefPage(ctx)},
  {
    pat: c.LINK_MY_CALENDAR,
    han: async ctx => (await u.imp(import(`./views/my-cal.mjs`))).MyCalPage(ctx),
  },
  {
    pat: c.LINK_MY_AI_ASSISTANT,
    han: async ctx => (await u.imp(import(`./views/my-acc-ai-assist.mjs`))).MyAiAssistantPage(ctx),
  },
  {
    pat: c.LINK_MY_AVAILABILITY,
    han: async ctx => (await u.imp(import(`./views/my-cal.mjs`))).WeeklySchedule(ctx),
  },

  ...promotionRoutes(),
  ...myCoursesRoutes(),

  {pat: c.LINK_ORGANIZATIONS, han: async ctx => (await u.imp(import(`./views/organizations.mjs`))).OrganizationsPage(ctx)},

  // For anyone wondering "WTF": "organiSations" -> "organiZations".
  {pat: `/organisations`, han: redir(`/organizations`)},

  // Refer a practitioner
  {pat: `/refer-a-practitioner`,                 han: async ctx => (await u.imp(import(`./views/refer-a-practitioner.mjs`))).ReferPractitioner(ctx)},
  {pat: `/refer-a-practitioner/congratulations`, han: async ctx => (await u.imp(import(`./views/refer-a-practitioner.mjs`))).ReferPractitionerCongratulations(ctx)},

  // [/^[/]stream[/]producer[/](?<id>[^/]+)$/, stream.StreamProducer],
  // [/^[/]stream[/]consumer[/](?<id>[^/]+)$/, stream.StreamConsumer],

  ...landings(),

  {
    pat: c.LINK_LP_METAPHORIC_CARDS,
    han: async ctx => (await u.imp(import(`./views/landings/lp-metaphoric-cards.mjs`))).LpMetaphoricCards(ctx),
  },

  {pat: c.LINK_REFERRAL,                 han: async ctx => (await u.imp(import(`./views/referral/referral.mjs`))).ReferralPage(ctx)},
  {pat: c.LINK_REFERRAL_TERMS,           han: async ctx => (await u.imp(import(`./views/referral/referral-terms.mjs`))).ReferralTermsPage(ctx)},

  {pat: c.LINK_FLASH,                    han: async ctx => (await u.imp(import(`./views/flash.mjs`))).FlashPage(ctx)},
  {pat: c.LINK_PAYMENT_SUCCESS,          han: async ctx => (await u.imp(import(`./views/flash.mjs`))).PaymentSuccessPage(ctx)},
  {pat: c.LINK_THANK_YOU,                han: async ctx => (await u.imp(import(`./views/flash.mjs`))).ThankYouPage(ctx)},

  {
    pat: `/embed/pay`,
    han: async ctx => (await u.imp(import(`./views/embed-pay.mjs`))).EmbedPayPage(ctx),
  },
  {
    pat: /^[/]embed[/]live-stream[/](?<id>[^/]+)$/,
    han: async ctx => (await u.imp(import(`./views/embed-live-stream.mjs`))).EmbedLiveStreamPage(ctx),
  },

  {pat: /^[/]steps[/](?<id>[^/]+)$/,     han: async ctx => (await u.imp(import(`./views/funnels.mjs`))).FunnelPage(ctx)},
  {pat: `/funnels/pract`,                han: async ctx => (await u.imp(import(`./views/funnels.mjs`))).FunnelPage(ctx, `fb7b65`)},
  {pat: `/funnels/user`,                 han: async ctx => (await u.imp(import(`./views/funnels.mjs`))).FunnelPage(ctx, `19acbd`)},

  {pat: c.LINK_MSGS,                     han: async ctx => (await u.imp(import(`./views/msg.mjs`))).GlobalMsgs(ctx)},
  {pat: c.LINK_MSGS_MY,                  han: async ctx => (await u.imp(import(`./views/msg.mjs`))).MyMsgs(ctx)},
  {pat: c.LINK_MSGS_FOLLOWING,           han: async ctx => (await u.imp(import(`./views/msg.mjs`))).FollowChanMsgs(ctx)},
  {pat: c.LINK_MSGS_REPLIES,             han: async ctx => (await u.imp(import(`./views/msg.mjs`))).ReplyMsgs(ctx)},
  {pat: c.LINK_MSGS_MENTIONS,            han: async ctx => (await u.imp(import(`./views/msg.mjs`))).MentionMsgs(ctx)},
  {pat: c.LINK_MSGS_MODERATIONS,         han: async ctx => (await u.imp(import(`./views/msg.mjs`))).ModerationMsgs(ctx)},

  {pat: `/msgs/pm`,                      han: async ctx => (await u.imp(import(`./views/msg.mjs`))).PersonalMsgs(ctx)},
  {pat: /^[/]msgs[/](?<id>[^/]+)$/,      han: async ctx => (await u.imp(import(`./views/msg.mjs`))).MsgThread(ctx)},
  {pat: /^[/]msgs[/]pm[/](?<id>[^/]+)$/, han: async ctx => (await u.imp(import(`./views/msg.mjs`))).MsgThreadPersonal(ctx)},

  {pat: `/unsubscribe`, han: async ctx => (await u.imp(import(`./views/unsubscribe.mjs`))).UnsubscribePage(ctx)},
  {pat: `/clear-all-browsers-data`, han: clearSiteData},

  ...rentFriendRoutes(),
  ...developmentRoutes(),

  {pat: /^[/]?(?<maybeSlug>[^/]+)[/]?$/, han: async ctx => (await u.imp(import(`./views/article.mjs`))).maybeRedirectFromOldLink(ctx)},
))

async function notFoundHandler(ctx) {
  return (await u.imp(import(`./views/layout.mjs`))).NotFoundPage(ctx)
}

function promotionRoutes() {
  return [
      {
        pat: c.LINK_MY_PAID_LISTING,
        han: async ctx => (await u.imp(import(`./views/my-acc-promotions.mjs`))).MyPromotionsPage(ctx),
      },
      {
        pat: c.LINK_MY_PROMOTIONS,
        han: async ctx => (await u.imp(import(`./views/promos.mjs`))).MyPromosPage(ctx),
      },
      {
        pat: c.LINK_MY_PROMOTION_SERVICE_PPC,
        han: async ctx => (await u.imp(import(`./views/promos.mjs`))).MyPromoServicePpcPage(ctx),
      },
      {
        pat: c.LINK_MY_PROMOTION_ARTICLE_LINK,
        han: async ctx => (await u.imp(import(`./views/promos.mjs`))).MyPromoArticleLinkPage(ctx),
      },
    ]
}

function landings() {
  return [
    {
      pat: c.LINK_ABOUT_US,
      han: async ctx => (await u.imp(import(`./views/landings/lp-about-us.mjs`))).AboutUsPage(ctx)
    },

    {pat: c.LINK_FOR_USERS,                han: async ctx => (await u.imp(import(`./views/landings/lp-for-users.mjs`))).LPForUsers(ctx)},
    {pat: c.LINK_FOR_DOCTORS,              han: async ctx => (await u.imp(import(`./views/landings/lps.mjs`))).LPForDoctors(ctx)},
    {pat: c.LINK_FOR_PRACTITIONERS,        han: async ctx => (await u.imp(import(`./views/landings/lps.mjs`))).LPForPractitioners(ctx)},
    {
      pat: c.LINK_FOR_ORGANIZATIONS,
      han: async ctx => (await u.imp(import(`./views/landings/lp-for-organizations.mjs`))).LPForOrganizations(ctx)
    },

    {pat: c.LINK_LP_SALES,                 han: async ctx => (await u.imp(import(`./views/landings.mjs`))).Sales(ctx)},
    {pat: c.LINK_LP_ENERGY,                han: async ctx => (await u.imp(import(`./views/landings.mjs`))).Energy(ctx)},
    {pat: c.LINK_LP_REIKI,                 han: async ctx => (await u.imp(import(`./views/landings.mjs`))).Reiki(ctx)},
    {pat: c.LINK_LP_DISTANT_HEALING,       han: async ctx => (await u.imp(import(`./views/landings.mjs`))).DistantHealing(ctx)},
    {
      pat: c.LINK_LP_ANXIETY,
      han: async ctx => (await u.imp(import(`./views/landings/lp-anxiety.mjs`))).Anxiety(ctx)
    },
    {
      pat: c.LINK_LP_STRESS,
      han: async ctx => (await u.imp(import(`./views/landings/lp-stress.mjs`))).Stress(ctx)
    },
    {
      pat: c.LINK_LP_NUTRITIONAL_THERAPY,
      han: async ctx => (await u.imp(import(`./views/landings/lp-nutritional-therapy.mjs`))).NutritionalTherapy(ctx)
    },
    {
      pat: c.LINK_LP_PSYCHOLOGIST,
      han: async ctx => (await u.imp(import(`./views/landings/lp-psychologist.mjs`))).Psychologist(ctx)
    },
    {
      pat: c.LINK_LP_COACHING,
      han: async ctx => (await u.imp(import(`./views/landings/lp-coaching.mjs`))).Coaching(ctx)
    },
    {
      pat: c.LINK_LP_FORTUNETELLING,
      han: async ctx => (await u.imp(import(`./views/landings/lp-fortunetelling.mjs`))).Fortunetelling(ctx)
    },
    {
      pat: c.LINK_LP_ENERGY_HEALING,
      han: async ctx => (await u.imp(import(`./views/landings/lp-energy-healing.mjs`))).EnergyHealing(ctx)
    },
  ]
}

// TODO exclude this code from the production build.
function developmentRoutes() {
  if (c.PUBLIC_RELEASE) return [testRoute()]
  if (!c.FEAT_NEW) return []

  return [
    {
      pat: c.LINK_SUBSCRIPTION,
      han: async ctx => (await u.imp(import(`./views/landings.mjs`))).MembershipPage(ctx)
    },
    {
      pat: c.LINK_EMBED_BUY_MEMBERSHIP,
      han: async ctx => (await u.imp(import(`./views/buy-membership.mjs`))).BuyMembershipEmbedPage(ctx)
    },

    {
      pat: /^[/]practitioners[/](?<id>[^/]+)[/]review$/,
      han: async ctx => (await u.imp(import(`./views/practitioner-leave-review.mjs`))).PractitionerLeaveReviewPage(ctx),
    },

    {pat: `/practitioner/review/invitation`,        han: async ctx => (await u.imp(import(`./views/practitioner-leave-review.mjs`))).PractitionerLeaveReviewInvitation(ctx)},

    {
      pat: c.LINK_MY_SALES_WITHDRAWAL,
      han: async ctx => (await u.imp(import(`./views/my-acc-wallet.mjs`))).Withdrawal(ctx),
    },

    {pat: c.LINK_MY_ORGANIZATIONS,                  han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx)},
    {pat: c.LINK_MY_MESSAGES,                       han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx)},
    {pat: c.LINK_MY_REVIEWS,                        han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx)},
    {pat: c.LINK_MY_PRODUCTS,                       han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx)},
    {pat: c.LINK_MY_STATISTICS,                     han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).MyProfilePage(ctx)},

    {pat: `/my-profile/deleted`,                    han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).DeletedAccountSignIn(ctx)},
    {pat: `/my-profile/restore`,                    han: async ctx => (await u.imp(import(`./views/my-acc-profile.mjs`))).AccountRestore(ctx)},
    {pat: `/my-feed-preferences`,                   han: async ctx => (await u.imp(import(`./views/my-feed-preferences.mjs`))).MyFeedPreferencesPage(ctx)},

    {pat: `/my-purchases/products`,                 han: async ctx => (await u.imp(import(`./views/my-acc-purchases-products.mjs`))).MyPurchasesProducts(ctx)},
    {pat: `/my-purchases/products/review`,          han: async ctx => (await u.imp(import(`./views/my-acc-purchases-products.mjs`))).ReviewAboutPurchasedProduct(ctx)},
    {pat: `/my-purchases/videos/review`,            han: async ctx => (await u.imp(import(`./views/my-acc-purchases-videos.mjs`))).ReviewAboutPurchasedVideo(ctx)},

    {pat: `/stub-for-no-support-browsers`,          han: async ctx => (await u.imp(import(`./views/stub-for-no-support-browsers.mjs`))).UnsupportedBrowserStubPage(ctx)},

    {pat: c.LINK_ADVERTISERS,                       han: async ctx => (await u.imp(import(`./views/advertisers.mjs`))).AdvertisersPage(ctx)},

    {pat: `/icons`,                                 han: async ctx => (await u.imp(import(`./views/icons.mjs`))).Icons(ctx)},

    testRoute(),
  ]
}

function purchasesRoutes() {
  return [
    // TODO get rid of redirect, send users directly to that page.
    // Redirects should be the last resort, not the first choice.
    {pat: c.LINK_MY_PURCHASES, han: redir(c.LINK_MY_PURCHASES_SERVICES)},

    {
      pat: c.LINK_MY_PURCHASES_SERVICES,
      han: async ctx => (await u.imp(import(`./views/my-purchases-sales.mjs`))).MyPurchasesServices(ctx),
    },
    {
      pat: c.LINK_MY_PURCHASES_EVENTS,
      han: async ctx => (await u.imp(import(`./views/my-purchases-sales.mjs`))).MyPurchasesEvents(ctx),
    },
    {
      pat: c.LINK_MY_PURCHASES_BOOKS,
      han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyPurchasesBooks(ctx),
    },
    {
      pat: c.LINK_MY_PURCHASES_VIDEOS,
      han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyPurchasesVideos(ctx),
    },
    {
      pat: c.LINK_MY_PURCHASES_COURSES,
      han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyPurchasesCourses(ctx),
    },
    {
      pat: c.LINK_MY_PURCHASES_GIFT_CARDS,
      han: async ctx => (await u.imp(import(`./views/my-acc-purchases-gift-cards.mjs`))).MyPurchasesGiftCards(ctx)
    },

    {
      pat: /^[/]my-purchases[/]services[/]review[/]cal_abs_timespans[/](?<id>[^/]+)[/]buyer/,
      han: async ctx => (await u.imp(import(`./views/my-purchases-sales.mjs`))).ReviewAboutPurchasedSessionBuyer(ctx),
    },
    {
      pat: /^[/]my-services[/]bookings[/]review[/]cal_abs_timespans[/](?<id>[^/]+)[/]seller/,
      han: async ctx => (await u.imp(import(`./views/my-purchases-sales.mjs`))).ReviewAboutPurchasedSessionSeller(ctx),
    }
  ]
}

function salesRoutes() {
  return [
    {
      pat: c.LINK_MY_SALES,
      han: async ctx => (await u.imp(import(`./views/account/my-sales-bookings.mjs`))).MySalesServices(ctx),
    },
    {
      pat: c.LINK_MY_SALES_EVENTS,
      han: async ctx => (await u.imp(import(`./views/account/my-sales-bookings.mjs`))).MySalesEvents(ctx),
    },
    {
      pat: c.LINK_MY_SALES_VIDEOS,
      han: async ctx => (await u.imp(import(`./views/account/my-sales-bookings.mjs`))).MySalesVideos(ctx),
    },
    {
      pat: c.LINK_MY_SALES_BOOKS,
      han: async ctx => (await u.imp(import(`./views/account/my-sales-bookings.mjs`))).MySalesBooks(ctx),
    },
    {
      pat: c.LINK_MY_SALES_COURSES,
      han: async ctx => (await u.imp(import(`./views/account/my-sales-bookings.mjs`))).MySalesCourses(ctx),
    },
    {
      pat: c.LINK_MY_SALES_CONNECT_SERVICES,
      han: async ctx => (await u.imp(import(`./views/my-acc-wallet.mjs`))).ConnectPaymentServices(ctx),
    },
  ]
}

function rentFriendRoutes() {
  return [
    {
      pat: c.LINK_BE_A_FRIEND,
      han: async ctx => (await u.imp(import(`./views/rent-friend/be-friend.mjs`))).BeFriend(ctx)
    },
    {
      pat: c.LINK_RENT_A_FRIEND,
      han: async ctx => (await u.imp(import(`./views/rent-friend/rent-friend.mjs`))).RentFriend(ctx)
    },
    {
      pat: c.LINK_RENT_A_FRIEND_TERMS,
      han: async ctx => (await u.imp(import(`./views/rent-friend/rent-friend-terms.mjs`))).RentFriendTerms(ctx)
    },
  ]
}

function testRoute() {
  return {
    pat: /^[/]test(?:$|[/])/,
    han: async ctx => (await u.imp(import(`./tests/test-ui.mjs`))).UiTestsPage(ctx),
  }
}

function myCoursesRoutes() {
  return [
    {
      pat: c.LINK_MY_COURSES,
      han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyCourses(ctx),
    },
    {
      pat: c.LINK_MY_COURSES_CREATE,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CourseCreatePage(ctx),
    },
    {
      pat: /^[/]my-courses[/](?<id>[^/]+)$/,
      han: async ctx => (await u.imp(import(`./views/my-acc-services.mjs`))).MyCourse(ctx),
    },
    {
      pat: /^[/]my-courses[/](?<id>[^/]+)[/]edit$/,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CourseEditPage(ctx),
    },
    {
      pat: /^[/]my-courses[/](?<id>[^/]+)[/]sections[/]create$/,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CourseSectionCreatePage(ctx),
    },
    {
      pat: /^[/]my-course-sections[/](?<id>[^/]+)[/]edit/,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CourseSectionEditPage(ctx),
    },
    {
      pat: /^[/]my-courses[/](?<slug>[^/]+)[/]moderation$/,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CourseModerationPage(ctx),
    },

    /*
    Pending features.
    {
      pat: /^[/]my-courses[/](?<slug>[^/]+)[/]publish$/,
      han: async ctx => (await u.imp(import(`./views/my-acc-service-forms.mjs`))).CoursePublishPage(ctx),
    },
    */
  ]
}

export class ReqRou extends u.MixCtxed(a.ReqRou) {
  constructor(...src) {
    super(...src)

    /*
    By default, the router's URL includes the origin, both on the client and in
    SSR. For our purposes, it's more convenient to exclude the origin, because
    we use this URL for constructing URLs for use in markup such as `href` in
    links, and our internal links must begin with `/` without an origin.
    */
    this.url.origin = ``
  }

  get Url() {return u.Url}

  async res() {
    try {
      const handler = this.findHandler() || notFoundHandler
      return await handler(this.ctx)
    }
    catch (err) {
      if (u.isErrAbort(err)) return undefined
      if (a.isInst(err, u.ErrRedir)) return err.resRedir()

      if (u.shouldLogErr(err)) {
        u.logAlert(Error(
          `unexpected error while rendering page for ${this.url}: ${err}`,
          {cause: err},
        ))
      }

      try {
        return await this.errResHtmlPage(err)
      }
      catch (err) {
        if (u.isErrAbort(err)) return undefined

        if (u.shouldLogErr(err)) {
          u.logAlert(Error(
            `unexpected secondary error while rendering error page for ${this.url}: ${err}`,
            {cause: err},
          ))
        }

        try {
          return await this.errResHtmlMini(err)
        }
        catch (err) {
          if (u.isErrAbort(err)) return undefined
          u.logAlert(Error(
            `unexpected tertiary error while rendering error for ${this.url}: ${err}`,
            {cause: err},
          ))
          return u.errStrRes(err)
        }
      }
    }
  }

  async errResHtmlPage(err) {
    if (u.isErrUnauthed(err)) {
      try {
        return await (await auth()).AuthLoginPage(this.ctx, {
          http: {status: c.HTTP_UNAUTHORIZED},
        })
      }
      catch (val) {err = val}
    }

    if (u.isErrRequiresPract(err)) {
      try {
        return await (await layout()).ErrorPageRequiresPract({
          ctx: this.ctx, error: err,
        })
      }
      catch (val) {err = val}
    }

    u.sentryCaptureException(err)
    return (await layout()).ErrorPage({ctx: this.ctx, error: err})
  }

  errResHtmlMini(err) {
    u.sentryCaptureException(err)

    return u.resHtml({body: errMarkup(err)}, {
      status: u.errHttpStatus(err),
      headers: [a.HEADER_HTML],
    })
  }

  findHandler() {return ROUTES.match(this)}
}

export function routeExists(path) {return !!ROUTES.match(new a.Rou(path))}

/*
This function is a lower-level fallback for error handling, which is invoked if
we fail to render a "full" error page. This means something goes wrong during
rendering, somewhere in our stack of React components or other view components.
Because this is meant for handling an error after other error handlers fail,
this function should avoid anything complicated. Even using React for rendering
in this function is very questionable.
*/
function errMarkup(err) {
  err = u.errStr(err)

  return E(`div`, {class: `mih-100vh`},
    E(`div`, {class: `flex-1 content-width col-sta-str pad-v-4x5`},
      E(`div`, {class: `col-cen-cen gap-xl pad-2`},
        E(`div`, {class: `col-cen-cen gap-lg`},
          E(`h2`, {class: `font-large`}, `Something went wrong. Sorry!`),
          a.vac(err) && E(`pre`, {class: `pad-sm`}, err),
        ),
        // Note: this intentionally uses a plain anchor, rather than pushstate
        // component `Link`. See the comment above.
        E(`a`, {href: `/`, class: `brand-link`}, c.CTA_BACK_HOME),
      ),
    ),
  )
}

/*
TODO: call `/api/v2/auth/logout`. The server immediately expires the current
session at the DB level.
*/
function clearSiteData() {
  return new Response(undefined, {headers: [[`clear-site-data`, `"cache", "cookies", "storage"`]]})
}

function auth() {return u.imp(import(`./views/auth.mjs`))}
function layout() {return u.imp(import(`./views/layout.mjs`))}
function redir(loc) {return a.bind(redirRes, loc)}
function redirRes(loc) {return u.resRedir(c.HTTP_MOVED_PERMANENTLY, loc)}
